import axios from 'axios';
import { fetchItemDetailsFailure } from './itemActions';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGIN_FAILURE_TESTING = 'USER_LOGIN_FAILURE_TESTING';
export const USER_LOGIN_2FA_REQUIRED = 'USER_LOGIN_2FA_REQUIRED';


export const USER_ROLES_REQUEST = 'USER_ROLES_REQUEST';
export const USER_ROLES_SUCCESS = 'USER_ROLES_SUCCESS';
export const USER_ROLES_FAILURE = 'USER_ROLES_FAILURE';

export const USERS_BY_ROLES_REQUEST = 'USERS_BY_ROLES_REQUEST';
export const USERS_BY_ROLES_SUCCESS = 'USERS_BY_ROLES_SUCCESS';
export const USERS_BY_ROLES_FAILURE = 'USERS_BY_ROLES_FAILURE';

export const FETCH_ALL_REGISTERD_USERS_REQUEST = 'FETCH_ALL_REGISTERD_USERS_REQUEST'
export const FETCH_ALL_REGISTERD_USERS_SUCCESS = 'FETCH_ALL_REGISTERD_USERS_SUCCESS'
export const FETCH_ALL_REGISTERD_USERS_FAILURE = 'FETCH_ALL_REGISTERD_USERS_FAILURE'

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE'

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE'

// // userRoleActionTypes.js
// export const FETCH_USERROLES_REQUEST = 'FETCH_USERROLES_REQUEST';
// export const FETCH_USERROLES_SUCCESS = 'FETCH_USERROLES_SUCCESS';
// export const FETCH_USERROLES_FAILURE = 'FETCH_USERROLES_FAILURE';

// export const UPDATE_USERROLE_REQUEST = 'UPDATE_USERROLE_REQUEST';
// export const UPDATE_USERROLE_SUCCESS = 'UPDATE_USERROLE_SUCCESS';
// export const UPDATE_USERROLE_FAILURE = 'UPDATE_USERROLE_FAILURE';

// export const DELETE_USERROLE_REQUEST = 'DELETE_USERROLE_REQUEST';
// export const DELETE_USERROLE_SUCCESS = 'DELETE_USERROLE_SUCCESS';
// export const DELETE_USERROLE_FAILURE = 'DELETE_USERROLE_FAILURE';



//users by user roles

export const usersByRolesRequest = () => {
    return {
        type: USERS_BY_ROLES_REQUEST,
    }
}

export const usersByRolesSuccess = (usersByRoles) => {
    return {
        type: USERS_BY_ROLES_SUCCESS,
        payload: usersByRoles,
    }
}

export const usersByRolesFailure = (error) => {
    return {
        type: USERS_BY_ROLES_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to fetch users by role',
    }
}

//user role management

export const userRoleRequest = () => {
    return {
        type: USER_ROLES_REQUEST,
    }
}

export const userRoleSuccess = (roles) => {
    return {
        type: USER_ROLES_SUCCESS,
        payload: roles,
    }
}

export const userRoleFailure = (error) => {
    return {
        type: USER_ROLES_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to fetch user roles',
    }
}

//user register

export const userRegisterRequest = () => {
    return {
        type: USER_REGISTER_REQUEST,
    }
}

export const userRegisterSuccess = (user) => {
    return {
        type: USER_REGISTER_SUCCESS,
        payload: user,
    }
}

export const userRegisterFailure = (error) => {
    return {
        type: USER_REGISTER_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to register user',
    }
}

//user Login

export const userLoginRequest = () => {
    return {
        type: USER_LOGIN_REQUEST,
    }
}

export const fetchAllRegisterdUsersRequest = () => {
    return {
        type: FETCH_ALL_REGISTERD_USERS_REQUEST
    }
}

export const fetchAllRegisterdUsersSuccess = (allRegisterdUsers) => {
    return {
        type: FETCH_ALL_REGISTERD_USERS_SUCCESS,
        payload: allRegisterdUsers
    }
}

export const fetchAllRegisterdUsersFailure = (error) => {
    return {
        type: FETCH_ALL_REGISTERD_USERS_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to fetch registered users'
    }
}


export const userLoginSuccess = (user, token, roles) => {
    const loginTime = Date.now();
    // console.log("roles",roles)
    // console.log("user",user)
    // const userRoleObj = roles.find((role) => role.id === Number(user.user_role));
    // console.log("userRoleObj",userRoleObj)
    // const roleName = userRoleObj ? userRoleObj.name : 'Unknown';

    localStorage.setItem('AuthToken', token);
    localStorage.setItem('loggedUserName', user.first_name);
    localStorage.setItem('auth', true);
    localStorage.setItem('user_role', user.role); // Store role name
    localStorage.setItem('user_id', user.id);
    localStorage.setItem('loggedDate', loginTime);

    return {
        type: USER_LOGIN_SUCCESS,
        payload: {
            user,
            token,
            login: true,
            role: user.role
        },
    };
};


export const userLoginFailure = (error) => {

    return {
        type: USER_LOGIN_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Login failed',
    }
}

//this use for ignore user login id type error in the front end but correct method is it is solevd from backend
export const userLoginFailureTesting = (error) => {

    return {
        type: USER_LOGIN_FAILURE_TESTING,
        payload: error?.response?.data?.message || error?.message || 'Login failed',
    }
}

export const userLoginTwoFactorRequired = (payload) => {
    return {
        type: USER_LOGIN_2FA_REQUIRED,
        payload,
    }
}

export const updateUserDetailsRequest = () => {
    return {
        type: USER_UPDATE_REQUEST,
    }
}

export const updateUserDetailsSuccess = (user) => {
    return {
        type: USER_UPDATE_SUCCESS,
        payload: user,
    }
}

export const updateUserFailure = (error) => {
    return {
        type: USER_UPDATE_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to update user',
    }
}

export const deleteUserDetailsRequest = (error) => {
    return {
        type: USER_DELETE_REQUEST,
        payload: error,
    }
}

export const deleteUserDetailsSuccess = (pk, error) => {
    return {
        type: USER_DELETE_SUCCESS,
    }
}

export const deleteUserFailure = (error) => {
    return {
        type: USER_DELETE_FAILURE,
        payload: error?.response?.data?.message || error?.message || 'Failed to delete user',
    }
}

//save new user

function getRoleNameByRoleId(roleId) {
    console.log(roleId);
    return async (roleId) => {
        try {
            const responce = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/role/${roleId}`);
        } catch (error) {

        }
    }
}

export const saveNewUser = (user) => {
    return async (dispatch) => {
        dispatch(userRegisterRequest(user))
        try {
            const { confirmPassword, ...payload } = user;
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth-register/`, payload);
            dispatch(userRegisterSuccess(response.data));
            return response.data;
        } catch (error) {
            dispatch(userRegisterFailure(error.response?.data?.message || error.message))
            throw error;
        }
    }
}

//user login

export const saveSessionData = async (user) => {
    console.log('passing user', user);
    try {
        const customers = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/companies/`);
        console.log('customers', customers)
        console.log('company_registration_ids', user.company_registration_ids[0]);
        const selectedCompany = customers.data?.find(company => company.id === user.company_registration_ids[0]);
        console.log('selectedCompany', selectedCompany)
        if (selectedCompany) {
            localStorage.setItem('userCompanie', selectedCompany.id);
            localStorage.setItem("selectedCompany", JSON.stringify({ value: selectedCompany.id, label: selectedCompany.company_name }));
            localStorage.setItem("user_companies", JSON.stringify(user.company_registration_id || user.company_registration_ids));
        } else {
            console.error("Company not found for the user");

        }

        // window.location.reload();
    } catch (error) {
        console.error("Error fetching company data:", error);
    }
};

export const userLoginAndAuthentication = (username, password) => {
    return async (dispatch) => {
        dispatch(userLoginRequest());

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth-login/`, { username, password });
            const { user, access } = response.data;

            const rolesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user-roles/`);
            const allRoles = rolesResponse.data.roles;

            await saveSessionData(user, allRoles);
            dispatch(userLoginSuccess(user, access, allRoles));
        } catch (error) {
            // Handle 403 with needs_2fa: true - NOT an error, expected behavior
            if (error.response?.status === 403 && error.response?.data?.needs_2fa) {
                const responseData = error.response.data;
                // Backend returns email and message as arrays, extract first element
                const email = Array.isArray(responseData.email) ? responseData.email[0] : responseData.email;
                const message = Array.isArray(responseData.message) ? responseData.message[0] : responseData.message;

                // Store credentials for retry after verification
                localStorage.setItem('pending_2fa', 'true');
                localStorage.setItem('pending_2fa_email', email);
                localStorage.setItem('pending_2fa_purpose', 'login');
                localStorage.setItem('pending_2fa_credentials', JSON.stringify({ username, password }));

                dispatch(userLoginTwoFactorRequired({ email, message }));
                return;
            }

            // Handle all other errors
            dispatch(userLoginFailureTesting(error.response?.data?.message || error.message));
        }
    };
};

export const initiateTwoFactor = (email, purpose = 'login') => {
    return async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth-2fa/initiate/`, { email, purpose });
            return response;
        } catch (error) {
            // Handle rate limiting (429 - Too Many Requests)
            if (error.response?.status === 429) {
                const rateLimitError = new Error('Please wait 30 seconds before requesting another code');
                rateLimitError.isRateLimit = true;
                throw rateLimitError;
            }
            console.error('Error initiating 2FA:', error);
            throw error;
        }
    };
};

export const verifyTwoFactor = (email, code) => {
    return async () => {
        return axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth-2fa/verify/`, { email, code });
    };
};


// export const userLoginAndAuthentication = (username, password) => {
//     let acccessToken;
//     return async (dispatch) => {
//         dispatch(userLoginRequest(username, password))
//         try {
//             // Include the username in the URL
//             const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/login_by_user_name/${username}/`, { username });
//             const { user } = response.data;
//             await saveSessionData(user);
//             acccessToken = "access";
//             dispatch(userLoginSuccess(user, acccessToken));
//         } catch (error) {
//             dispatch(userLoginFailureTesting(error.response?.data?.message || error.message))
//         }
//     }
// }

//fetch user roles

export const fetchAllUserRoles = () => {
    return async (dispatch) => {
        dispatch(userRoleRequest())
        try {
            const responce = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user-roles/`);
            dispatch(userRoleSuccess(responce.data.roles));
        } catch (error) {
            dispatch(userRoleFailure(error));
        }
    }
}

// Fetch users by role ID
export const fetchUsersByRoleId = (roleId) => {
    return async (dispatch) => {
        dispatch(usersByRolesRequest());
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users-by-role/${roleId}/`);
            dispatch(usersByRolesSuccess(response.data));
        } catch (error) {
            dispatch(usersByRolesFailure(error.response?.data?.message || error.message));
        }
    };
};

// Update user by user ID
export const updateUserByUserId = (id, userData) => {
    return async (dispatch) => {
        dispatch(updateUserDetailsRequest());
        try {
            console.log('Updating user with ID:', id);
            console.log('User data:', userData);
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/user/update/${id}/`, userData);
            console.log('Update response:', response.data);
            dispatch(updateUserDetailsSuccess(response.data));
            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            console.error('Error response:', error.response?.data);
            const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message;
            dispatch(updateUserFailure(errorMessage));
            throw error;
        }
    };
};


export const fetchAllUsersRegisterd = () => {
    return async (dispatch) => {
        dispatch(fetchAllRegisterdUsersRequest())
        try {
            const responce = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/all-custom-users/`)
            dispatch(fetchAllRegisterdUsersSuccess(responce.data.users))
        } catch (error) {
            dispatch(fetchAllRegisterdUsersFailure(error))
        }
    }
}

export const updateUserRoleById = (id, data) => {
    return async (dispatch) => {
        dispatch({ type: 'UPDATE_USERROLE_REQUEST' });
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/user-roles/${id}/`, data);
            dispatch({ type: 'UPDATE_USERROLE_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'UPDATE_USERROLE_FAILURE', payload: error });
        }
    };
};

export const deleteUserByUserId = (userId) => {
    return async (dispatch) => {
        dispatch({ type: "USER_DELETE_REQUEST" });
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/user/delete/${userId}/`);
            dispatch({ type: "USER_DELETE_SUCCESS", payload: userId });
        } catch (error) {
            dispatch({
                type: "USER_DELETE_FAILURE",
                payload: error.response?.data?.message || error.message || "Failed to delete user",
            });
            throw error;
        }
    };
};

// ================================ privileges ===========================================
// Fetch all privileges
export const fetchAllPrivileges = () => {
    return async (dispatch) => {
        dispatch({ type: 'FETCH_PRIVILEGES_REQUEST' });
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/privileges/`);
            dispatch({ type: 'FETCH_PRIVILEGES_SUCCESS', payload: response.data.results });
        } catch (error) {
            dispatch({ type: 'FETCH_PRIVILEGES_FAILURE', payload: error });
        }
    }
}

// Create privilege             
export const createPrivilege = (privilegeData) => {
    return async (dispatch) => {
        dispatch({ type: 'CREATE_PRIVILEGE_REQUEST' });
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/privileges/`, privilegeData);
            dispatch({ type: 'CREATE_PRIVILEGE_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'CREATE_PRIVILEGE_FAILURE', payload: error });
        }
    }
}

// Update privilege
export const updatePrivilegeById = (id, privilegeData) => {
    return async (dispatch) => {
        dispatch({ type: 'UPDATE_PRIVILEGE_REQUEST' });
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/privileges/${id}/`, privilegeData);
            dispatch({ type: 'UPDATE_PRIVILEGE_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'UPDATE_PRIVILEGE_FAILURE', payload: error });
        }
    }
}

// Delete privilege
export const deletePrivilegeById = (id) => {
    return async (dispatch) => {
        dispatch({ type: 'DELETE_PRIVILEGE_REQUEST' });
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/privileges/${id}/`);
            dispatch({ type: 'DELETE_PRIVILEGE_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'DELETE_PRIVILEGE_FAILURE', payload: error });
        }
    }
}



// ================================ change password ======================================
// Add these action types at the top with your other action types
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// Action Creators
export const changePasswordRequest = () => ({
    type: CHANGE_PASSWORD_REQUEST
});

export const changePasswordSuccess = (message) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: message
});

export const changePasswordFailure = (error) => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload: error
});

// Async Action for changing password
export const changeUserPassword = (userId, passwordData) => {
    return async (dispatch) => {
        dispatch(changePasswordRequest());

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('AuthToken')}`,
                }
            };

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/auth-change-password/`,
                {
                    user_id: userId,
                    current_password: passwordData.current_password,
                    new_password: passwordData.new_password,
                    confirm_new_password: passwordData.confirm_new_password
                },
                config
            );

            dispatch(changePasswordSuccess(response.data.msg || "Password changed successfully"));
            return response;

        } catch (error) {
            dispatch(changePasswordFailure(error.response?.data || "Password change failed"));
            throw error;  // Re-throw to catch in component
        }
    };
};

